import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7967ea0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "address"
}
const _hoisted_2 = {
  key: 0,
  class: "tariff-content-com"
}
const _hoisted_3 = {
  key: 0,
  class: "tips"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/Client/icon_help.png",
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OCSのリアルタイム口座での税金引き落としをご利用の場合、事前にNACCSとOCS Japanへの登録が必要です。詳しくは担当者までご確認ください。", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "tariffType1"
}
const _hoisted_8 = { class: "flex-ter tax-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require-asterisk" }, "* ", -1))
const _hoisted_10 = { class: "flex tax-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require-asterisk" }, "* ", -1))
const _hoisted_12 = { class: "flex tax-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require-asterisk" }, "* ", -1))
const _hoisted_14 = { class: "flex tax-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require-asterisk" }, "* ", -1))
const _hoisted_16 = {
  key: 0,
  class: "flex tax-item"
}
const _hoisted_17 = {
  key: 1,
  class: "address"
}
const _hoisted_18 = { class: "tariffTips" }
const _hoisted_19 = { class: "tariffTips" }
const _hoisted_20 = { class: "tariffWarning" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import ChooseTaxAccount from './ChooseTaxAccount.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { taxAccountList, checkTaxWhite } from '@/apis/user'
import { useStore } from 'vuex'
import { isJA, isWhiteHiddenRMB, useSite } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
    allIncludeFlag: { type: Boolean, required: false },
    isStockJp: { type: Boolean, required: true }
  },
  setup(__props: any, { expose }) {

const props = __props as { allIncludeFlag?: boolean, isStockJp: boolean }
// 需要加一点注释呢


watch(() => props.allIncludeFlag, (v) => {
  if (v) {
    tariffType.value = 0
  }
})

const store = useStore()
const site = useSite()

const isTaxWhite = ref(false)
checkTaxWhite({ mainCustomerId: store.getters.user?.mainCustomerId }).then(res => {
  isTaxWhite.value = res.data
})
// deliveryType
const tariffType = ref(0)
const priceDeclarationType = ref(0)

const taxAccount = ref({
  financialInstitutionCode: ''
})
const defaultSelection = ref({})
taxAccountList({ pageNum: 1, pageSize: 50, customerShopId: store.getters.curShop }).then(res => {
  const data = res.data.records.filter((v: any) => v.isDefault)[0]
  if (data) {
    taxAccount.value = data
    defaultSelection.value = data
  }
})

const rules = {
  declarationDiscount: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) return callback(t('申报折扣不能为空'))
        if (isNaN(Number(val))) {
          callback(t('申报折扣格式不正确'))
          return
        } else if (!(Number(val) > 50)) {
          callback(t('申报折扣必须大于50'))
          return
        } else if (!(Number(val) < 100)) {
          callback(t('申报折扣必须小于100'))
          return
        }
        callback()
      },
      required: true,
      trigger: 'blur'
    }
  ]
}
const priceDeclarationForm = ref({
  declarationDiscount: 99
})
const declarationDiscountInput = (val: string) => {
  priceDeclarationForm.value.declarationDiscount = Math.floor(Number(val))
}

const visible = ref(false)
const chooseTaxAccount = () => {
  visible.value = true
}

const priceDeclarationTypeRef = ref()

const updateSel = (val: any) => {
  taxAccount.value = val[0]
  defaultSelection.value = val[0]
}

const taxValid = async () => {
  if (site !== 'ja') {
    return true
  }

  let priceDeclarationValid = false
  let taxAccountValid = false

  if (isTaxWhite.value) {
    if (priceDeclarationType.value === 1) {
      await priceDeclarationTypeRef.value.validate((valid) => {
        console.log(valid)
        if (valid) {
          priceDeclarationValid = true
        }
      })
    } else {
      priceDeclarationValid = true
    }
  } else {
    priceDeclarationValid = true
  }

  if (tariffType.value === 1) {
    if (taxAccount.value.financialInstitutionCode) {
      taxAccountValid = true
    } else {
      ElMessage.warning(t('扣税账号不能为空'))
    }
  } else {
    taxAccountValid = true
  }

  if (taxAccountValid && priceDeclarationValid && (priceDeclarationType.value === 1)) {
    return ElMessageBox.confirm(t('您未选择按照原价申报，存在监管风险，海关可能会扣留货物'),
      t('提示'),
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: t('修改一下'),
        cancelButtonText: t('继续创建'),
        type: 'success'
      }
    ).then(() => {
      return false
    }).catch(() => {
      return taxAccountValid && priceDeclarationValid
    })
  }
  return taxAccountValid && priceDeclarationValid
}
// 父组件会调用这个方法
const getTaxData = async () => {
  if (site !== 'ja') {
    return {}
  }
  let taxData = {
    tariffType: tariffType.value
  }
  tariffType.value === 1 && (taxData = Object.assign(taxData, taxAccount.value))
  if (isTaxWhite.value) {
    taxData.priceDeclarationType = priceDeclarationType.value
    priceDeclarationType.value === 1 && (taxData = Object.assign(taxData, { declarationDiscount: Number(priceDeclarationForm.value.declarationDiscount) / 100 }))
  }
  return taxData
}

expose({
  taxValid,
  getTaxData,
  setInitTariffType(_tariffType: number) {
    tariffType.value = _tariffType
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(site) === 'ja' && !__props.allIncludeFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('关税收取方式')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: tariffType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tariffType).value = $event)),
                    style: {"flex-shrink":"0","width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('请求书请求')) + _toDisplayString(_unref(t)('(物流公司直接向您收取关税和通关手续费)')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('账号扣税')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          (tariffType.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (tariffType.value === 1 && _unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
                  : _createCommentVNode("", true),
                (tariffType.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_unref(t)('金融机构代码')) + "：", 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(taxAccount.value.financialInstitutionCode || '-') + " ", 1),
                          (!__props.isStockJp)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "text",
                                class: "cursor-pt ml_20",
                                onClick: chooseTaxAccount
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('选择扣税账号')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _hoisted_11,
                          _createTextVNode(_toDisplayString(_unref(t)('分行代码')) + "：", 1)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(taxAccount.value.branchCode || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _hoisted_13,
                          _createTextVNode(_toDisplayString(_unref(t)('账号_关税')) + "：", 1)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(taxAccount.value.taxDeductionAccount || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _hoisted_15,
                          _createTextVNode(_toDisplayString(_unref(t)('进口商标准代码')) + "：", 1)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(taxAccount.value.importerCode || '-'), 1)
                      ]),
                      (__props.isStockJp)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_el_button, {
                              type: "text",
                              class: "cursor-pt ml_20 stock-btn",
                              onClick: chooseTaxAccount
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("+ " + _toDisplayString(_unref(t)('选择扣税账号')), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(site) === 'ja' && isTaxWhite.value && !_unref(isWhiteHiddenRMB)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('价格申报规则')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: priceDeclarationType.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((priceDeclarationType).value = $event)),
                    style: {"flex-shrink":"0","width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: 0,
                        style: {"width":"270px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('按照原价申报')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('整单按固定折扣申报')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (priceDeclarationType.value === 1)
                    ? (_openBlock(), _createBlock(_component_el_form, {
                        key: 0,
                        ref: (_value, _refs) => {
                          _refs['priceDeclarationTypeRef'] = _value
                          priceDeclarationTypeRef.value = _value
                        },
                        model: priceDeclarationForm.value,
                        rules: rules
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('申报折扣'),
                            prop: "declarationDiscount"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_input_number, {
                                  type: "number",
                                  modelValue: priceDeclarationForm.value.declarationDiscount,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((priceDeclarationForm.value.declarationDiscount) = $event)),
                                  step: 1,
                                  max: 99,
                                  min: 51,
                                  style: {"width":"200px"},
                                  onInput: declarationDiscountInput
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("span", _hoisted_18, "%  " + _toDisplayString(_unref(t)('价格申报＝THE直航采购商品单价（元）×申报比率')), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('关于价格申报比率的填写，因为只能填写51%~99%的范围，所以填写时请注意数值')), 1),
                                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('【注意】进行过少申报时，海关有没收运输行李的风险※本公司不承担责任。请谅解')), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["model"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(ChooseTaxAccount, {
      visible: visible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      defaultSelection: defaultSelection.value,
      onUpdateSel: updateSel
    }, null, 8, ["visible", "defaultSelection"])
  ], 64))
}
}

})